// Yuzenya — AI-generated cinematic imagery (served from backend) + KOTO architecture
const BACKEND = process.env.REACT_APP_BACKEND_URL;
const GEN = (name) => `${BACKEND}/api/static/generated/${name}.png`;
// Self-hosted assets (served from the app's own origin — no third-party CDN dependency)
const LOCAL = (file) => `${process.env.PUBLIC_URL || ""}/assets/${file}`;

export const IMG = {
  // AI-generated (Gemini Nano Banana) — cinematic Scandinavian retreat imagery
  hero: LOCAL("hero.png"),
  heroAlt: LOCAL("hero.png"),
  morningLake: GEN("morningLake"),
  forest:
    "https://customer-assets-0z36b82j.emergentagent.net/job_nordic-retreat-hub/artifacts/evdwvvfe_yuzenya_entry_gate_summer.png",
  nourishment: GEN("nourishment"),
  cabinInterior: GEN("cabinInterior"),
  stars: GEN("stars"),
  coldPlunge: GEN("coldPlunge"),
  sunset: GEN("sunset"),

  // Three Transformative Experiences — user-supplied editorial photography
  // 01 Retreat, 02 Nourishment, 03 Nature (hero crop)
  experienceRetreat:
    "https://customer-assets-0z36b82j.emergentagent.net/job_nordic-retreat-hub/artifacts/l8p9bbsu_Experience%20Retreat.png",
  experienceNourishment:
    "https://customer-assets-0z36b82j.emergentagent.net/job_nordic-retreat-hub/artifacts/3esz2xy0_Experience%20Nourishment.png",
  pillar_mindfulness: GEN("pillar_mindfulness"),
  pillar_nourishment: GEN("pillar_nourishment"),

  // KOTO architectural photography (user-supplied)
  kotoTwinCabins:
    "https://customer-assets.emergentagent.com/job_nordic-retreat-hub/artifacts/r6fnxffj_KOTO%20cabin%20on%20plot%20Norway%20-%20chatgpt%20image%202.png",
  kotoMoorHall:
    "https://customer-assets.emergentagent.com/job_nordic-retreat-hub/artifacts/alj4qzk6_Koto_MoorHall_Photographer_Olco-Studios-26.jpg.webp",
  kotoSauna:
    "https://customer-assets.emergentagent.com/job_nordic-retreat-hub/artifacts/5lvcom6m_koto-sauna.jpg.webp",
  kotoSpa:
    "https://customer-assets.emergentagent.com/job_nordic-retreat-hub/artifacts/htjmsrkl_Koto-Spa-1.jpg.webp",

  // Vision section — KOTO Spa cabin against snowy mountains (self-hosted)
  vision: LOCAL("vision-cabin.webp"),

  // Architecture story — KOTO MoorHall
  architecture:
    "https://customer-assets.emergentagent.com/job_nordic-retreat-hub/artifacts/alj4qzk6_Koto_MoorHall_Photographer_Olco-Studios-26.jpg.webp",

  // Nourishment story — Experience Nourishment (Nordic table, lake view)
  longevityStory:
    "https://customer-assets-0z36b82j.emergentagent.net/job_nordic-retreat-hub/artifacts/3esz2xy0_Experience%20Nourishment.png",

  // Sauna story — KOTO sauna by water
  sauna:
    "https://customer-assets.emergentagent.com/job_nordic-retreat-hub/artifacts/5lvcom6m_koto-sauna.jpg.webp",
  // Nature pillar image — cropped hero (misty lake at dawn, self-hosted)
  pillar_sauna: LOCAL("hero.png"),

  // Rest pillar — KOTO twin cabins in pine forest
  pillar_rest:
    "https://customer-assets.emergentagent.com/job_nordic-retreat-hub/artifacts/z09dyfmq_Scherm%C2%ADafbeelding%202026-06-03%20om%2010.59.37.png",

  // Masterplan illustration — KOTO twin cabins
  masterplan:
    "https://customer-assets.emergentagent.com/job_nordic-retreat-hub/artifacts/r6fnxffj_KOTO%20cabin%20on%20plot%20Norway%20-%20chatgpt%20image%202.png",
};

// Hero still image supplies the cinematic background (ambient Ken Burns motion
// is handled in CSS). External stock video was dropped — providers block hotlinking.

// Yuzenya logos — freestanding marks (self-hosted from the app's own origin)
// Light version (ivory mark on transparent) → use on dark backgrounds
export const LOGO_LIGHT = `${process.env.PUBLIC_URL || ""}/assets/yuzenya-logo-light.png`;
// Dark version (forest-green mark on transparent) → use on light backgrounds
export const LOGO_DARK = `${process.env.PUBLIC_URL || ""}/assets/yuzenya-logo-dark.png`;
// Backwards-compat alias (defaults to light for existing dark-bg uses)
export const LOGO_URL = LOGO_LIGHT;
